import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Autoplay, A11y, Lazy } from "swiper";
import "swiper/swiper-bundle.css";
import sal from "sal.js";
import api from "../../../services/api";

SwiperCore.use([Navigation, Autoplay, Lazy, A11y]);

const SpecialitySection = () => {
  const navigate = useNavigate();
  const [specialities, setSpecialities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpecialities = async () => {
      try {
        const res = await api.get("/api/specialties-descriptions");

        const formatted = res.data
          .filter(item => item.description_section)
          .map(item => ({
            title: item.description_section.title || item.name,
            subtitle: item.description_section.description || "",
            img: item.description_section.icon,
            navigate: `/specialties/${item.slug}`
          }));

        setSpecialities(formatted);
      } catch (error) {
        console.error("Failed to load specialities", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSpecialities();
  }, []);

  useEffect(() => {
    if (!loading) {
      document.querySelectorAll(".progress-card").forEach((card, index) => {
        card.setAttribute("data-sal", "slide-up");
        card.setAttribute("data-sal-duration", "1000");
        card.setAttribute("data-sal-delay", 100 + index * 200);
      });

      sal({ threshold: 0.2, once: true });
    }
  }, [loading]);

  if (loading || specialities.length === 0) return null;

  return (
    <section className="progress-section speciality-section py-4 py-md-5">
      <div className="container">
        <div className="col-12 mb-3 mb-md-5 text-center">
          <h2 className="section-title">Lifeline Tulasi Specialities</h2>
          <p className="section-subtitle">A New Form of Personalized Care</p>
        </div>

        {/* Swiper Carousel */}
        <Swiper
          navigation={false}
          pagination={false}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          lazy={true}
          a11y={{ enabled: true }}
          spaceBetween={20}
          slidesPerView={4}
          breakpoints={{
            1200: { slidesPerView: 4 },
            992: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          onInit={(swiper) => setTimeout(() => swiper.update(), 50)}
          className="speciality-swiper"
        >
          {specialities.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="progress-card"
                onClick={() => navigate(item.navigate)}
                style={{ cursor: "pointer" }}
              >
                <div className="progress-img-wrapper mb-4">
                  <img src={`${process.env.REACT_APP_WEB_URL}${item.img}`} alt={item.title} />
                </div>
                <h2 className="progress-title text-center">{item.title}</h2>
                <p className="progress-subtitle">{item.subtitle}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="col-12 text-center mt-2 mt-md-5">
          <Link to="/specialitieslist" className="about-btn">
            View All Specialities
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SpecialitySection;
